import React, { useState } from 'react';
import axios from '../api/axios';
import './Login.css';

export default function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!username || !password) {
      setError('Please enter both username and password');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post('/api/users/login', {
        username,
        password
      });

      if (response.data.success) {
        // Store user info in localStorage
        localStorage.setItem('userId', response.data.userId);
        localStorage.setItem('username', response.data.username);
        
        // Call parent callback with user info
        onLoginSuccess({
          userId: response.data.userId,
          username: response.data.username
        });
      }
    } catch (error) {
      console.error('Login error:', error);
      if (error.response?.data?.message) {
        setError(error.response.data.message);
      } else {
        setError('Login failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-form-container">
        <img src="/image/logo.png" alt="Lead Huntrix Logo" className="login-logo" />
        <h2 className="login-title">Lead Huntrix</h2>

      {error && (
        <div className="login-error">
          <span>{error}</span>
        </div>
      )}

      <button type="button" className="google-btn">
        Sign in with Google
      </button>

      <form onSubmit={handleSubmit}>
        <div className="login-form-group">
          <label htmlFor="username">Username</label>
          <input
            id="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter your username"
            disabled={loading}
            autoFocus
          />
        </div>

        <div className="login-form-group">
          <label htmlFor="password">Password</label>
          <div className="password-input-wrapper">
            <input
              id="password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              disabled={loading}
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword(!showPassword)}
              tabIndex={-1}
            >
              <i className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"}></i>
            </button>
          </div>
        </div>

        <button 
          type="submit" 
          className="login-submit-btn"
          disabled={loading}
        >
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
      </form>

        <div className="login-footer">
          <p>© 2024 Lead Huntrix. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}
